import React, { ReactElement, useEffect, useState } from "react";
import "./App.css";
import { Route, Routes } from "react-router-dom";
import { RoutePaths } from "./enumStrings";
import useInitialAuth from "./hooks/useInitalAuth";
import getApolloClient from "./apolloClient";
import { ApolloClient, ApolloProvider } from "@apollo/client";
import FullPageLoader from "./components/common/FullPageLoader";
import Root from "./components/pages/Root/Root";
import Login from "./components/pages/Auth/Login";
import ForgotPassword from "./components/pages/Auth/ForgotPassword";
import NewPassword from "./components/pages/Auth/NewPassword";
import Error500 from "./components/pages/ErrorPages/Error500";
import LoggedInApp from "./components/LoggedInApp";
import NativeDatePickerClickOpener from "./components/common/dashboard/NativeDatePickerClickOpener";
import { useHandleLogout } from "./hooks/useHandleLogout";

const App = (): ReactElement => {
  const [client, setClient] = useState(
    null as unknown as ApolloClient<unknown>
  );
  const [isLoggedIn, setIsLoggedIn] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useInitialAuth(setIsLoggedIn);

  const handleLogout = useHandleLogout();

  useEffect(() => {
    getApolloClient(handleLogout).then((newClient) => {
      setClient(newClient);
      setIsLoading(false);
    });
  }, [handleLogout, isLoggedIn]);

  if (isLoading || isLoggedIn === null) {
    return <FullPageLoader />;
  }

  return (
    <ApolloProvider client={client}>
      <NativeDatePickerClickOpener />
      <Routes>
        <Route path={RoutePaths.error500} element={<Error500 />} />
        <Route path={RoutePaths.home} element={<Root />} />
        {isLoggedIn === false ? (
          <Route path="*" element={<LoggedOutApp />} />
        ) : (
          <Route path="*" element={<LoggedInApp />} />
        )}
      </Routes>
    </ApolloProvider>
  );
};

const LoggedOutApp = (): ReactElement => {
  return (
    <Routes>
      <Route path={RoutePaths.login} element={<Login />} />
      <Route path={RoutePaths.forgotPassword} element={<ForgotPassword />} />
      <Route path={RoutePaths.newPassword} element={<NewPassword />} />
    </Routes>
  );
};

export default App;
